import { render } from "./Solutions.vue?vue&type=template&id=2d2279c4&lang=pug"
import script from "./Solutions.vue?vue&type=script&setup=true&lang=js"
export * from "./Solutions.vue?vue&type=script&setup=true&lang=js"

import "./Solutions.vue?vue&type=style&index=0&id=2d2279c4&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__